/**
 * Property listing cards: dynamic filter updates without full page reload.
 * Shows "Searching…" overlay, fetches fragment via REST, updates content and URL.
 */
(function () {
  'use strict';

  function getBlockWrapper() {
    return document.querySelector('.block-property-listing-cards[data-rest-url]');
  }

  function getContentEl() {
    return document.getElementById('property-listing-content');
  }

  function getForm() {
    return document.querySelector('.property-listing-sidebar__form');
  }

  function getOverlay() {
    return document.getElementById('property-listing-search-overlay');
  }

  function formToParams(form) {
    if (!form) return {};
    var fd = new FormData(form);
    var params = {};
    fd.forEach(function (value, key) {
      if (value === '' || value == null) return;
      var baseKey = key.replace(/\[\]$/, '');
      if (baseKey !== key) {
        if (!params[baseKey]) params[baseKey] = [];
        params[baseKey].push(value);
      } else {
        params[key] = value;
      }
    });
    return params;
  }

  function paramsToQueryString(params) {
    var search = new URLSearchParams();
    Object.keys(params || {}).forEach(function (key) {
      var val = params[key];
      if (Array.isArray(val)) {
        val.forEach(function (v) { search.append(key + '[]', v); });
      } else {
        search.set(key, val);
      }
    });
    var q = search.toString();
    return q ? '?' + q : '';
  }

  function urlToParams() {
    var search = window.location.search;
    if (!search) return {};
    var params = {};
    new URLSearchParams(search).forEach(function (v, k) { params[k] = v; });
    return params;
  }

  /** Form params plus current tab/view from URL so filtering keeps Rent vs Buy and view mode */
  function getListingParams() {
    var form = getForm();
    var params = form ? formToParams(form) : {};
    var url = urlToParams();
    if (url.tab) params.tab = url.tab;
    if (url.view) params.view = url.view;
    return params;
  }

  function showOverlay() {
    var overlay = getOverlay();
    if (overlay) {
      overlay.removeAttribute('hidden');
      overlay.setAttribute('aria-busy', 'true');
    }
  }

  function hideOverlay() {
    var overlay = getOverlay();
    if (overlay) {
      overlay.setAttribute('hidden', '');
      overlay.setAttribute('aria-busy', 'false');
    }
  }

  function updateListingMobileBar(countText) {
    var bar = document.getElementById('property-listing-mobile-bar');
    var countEl = document.getElementById('property-listing-mobile-bar-count');
    if (!bar || !countEl) return;
    if (countText != null) {
      countEl.textContent = countText;
      return;
    }
    var content = getContentEl();
    var cards = content ? content.querySelectorAll('.site-property-inner-column-wrapper') : [];
    var n = cards.length;
    countEl.textContent = n === 0 ? 'No properties found.' : (n === 1 ? '1 property' : n + ' properties');
    bar.setAttribute('aria-hidden', 'false');
  }

  function closeListingSidebar() {
    var wrapper = getBlockWrapper();
    var sidebar = document.getElementById('property-listing-sidebar');
    var toggle = document.getElementById('property-listing-sidebar-toggle');
    if (sidebar) sidebar.classList.remove('property-listing-sidebar--open');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    if (wrapper) wrapper.classList.remove('property-listing-filters-open');
    document.body.classList.remove('property-listing-filters-open');
  }

  function loadListing(params, pushState) {
    var wrapper = getBlockWrapper();
    var content = getContentEl();
    if (!wrapper || !content || !wrapper.dataset.restUrl) return;

    var restUrl = wrapper.dataset.restUrl;
    var permalink = content.dataset.permalink || (window.location.origin + window.location.pathname);
    var postsPerPage = content.dataset.postsPerPage || '9';
    var columns = content.dataset.columns || '3';
    var defaultTab = content.dataset.defaultTab || 'buy';
    var defaultLayout = content.dataset.defaultLayout || 'cards';

    var search = new URLSearchParams();
    search.set('permalink', permalink);
    search.set('posts_per_page', postsPerPage);
    search.set('columns', columns);
    search.set('default_tab', defaultTab);
    search.set('default_layout', defaultLayout);
    Object.keys(params || {}).forEach(function (key) {
      var val = params[key];
      if (Array.isArray(val)) {
        val.forEach(function (v) { search.append(key + '[]', v); });
      } else {
        search.set(key, val);
      }
    });

    showOverlay();
    var searchLabel = wrapper.dataset.searchLabel || 'Searching…';
    updateListingMobileBar(searchLabel);

    fetch(restUrl + '?' + search.toString(), { method: 'GET', headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data && data.html != null) {
          content.innerHTML = data.html;
          if (pushState !== false) {
            var qs = paramsToQueryString(params || {});
            var url = permalink.replace(/\?.*$/, '') + qs;
            window.history.pushState({ listingParams: params || {} }, '', url);
          }
          reattachSortSelect(content);
          updateListingMobileBar();
        }
      })
      .catch(function () {
        if (pushState !== false && (params || {}).tab) {
          var qs = paramsToQueryString(params || {});
          window.location.href = (content.dataset.permalink || window.location.origin + window.location.pathname).replace(/\?.*$/, '') + qs;
        }
      })
      .finally(function () {
        hideOverlay();
        updateListingMobileBar();
      });
  }

  function reattachSortSelect(container) {
    if (!container) container = getContentEl();
    var select = container && container.querySelector('#plc-sort-select');
    if (select && select.dataset.baseUrl) {
      select.addEventListener('change', function () {
        var params = getListingParams();
        params.sort = select.value;
        loadListing(params);
      });
    }
  }

  function init() {
    var wrapper = getBlockWrapper();
    if (!wrapper || !wrapper.dataset.restUrl) return;

    var form = getForm();
    var content = getContentEl();
    if (!content) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      loadListing(getListingParams());
    });

    form.addEventListener('change', function () {
      var debounce = form._listingChangeDebounce;
      if (debounce) clearTimeout(debounce);
      form._listingChangeDebounce = setTimeout(function () {
        loadListing(getListingParams());
      }, 400);
    });

    form.querySelectorAll('input[type="text"], input[type="number"]').forEach(function (input) {
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          loadListing(getListingParams());
        }
      });
    });

    var resetLink = wrapper && wrapper.querySelector('.property-listing-reset-link');
    if (resetLink && form) {
      resetLink.addEventListener('click', function (e) {
        var href = resetLink.getAttribute('href');
        if (href) {
          e.preventDefault();
          form.reset();
          var keep = {};
          var url = urlToParams();
          if (url.tab) keep.tab = url.tab;
          if (url.view) keep.view = url.view;
          loadListing(keep);
          var base = href.replace(/\?.*$/, '');
          if (keep.tab || keep.view) base += '?' + new URLSearchParams(keep).toString();
          window.history.pushState({ listingParams: keep }, '', base);
        }
      });
    }

    document.addEventListener('click', function (e) {
      var tab = e.target && e.target.closest('.property-listing-tab-link');
      var viewLink = e.target && e.target.closest('.property-listing-view-link');
      if (tab && tab.href) {
        e.preventDefault();
        try {
          var u = new URL(tab.href, window.location.origin);
          var params = formToParams(getForm());
          u.searchParams.forEach(function (v, k) { params[k] = v; });
          loadListing(params);
        } catch (err) {
          window.location.href = tab.href;
        }
      } else if (viewLink && viewLink.href) {
        e.preventDefault();
        try {
          var u = new URL(viewLink.href, window.location.origin);
          var params = formToParams(getForm());
          u.searchParams.forEach(function (v, k) { params[k] = v; });
          loadListing(params);
        } catch (err) {
          window.location.href = viewLink.href;
        }
      }
    });

    reattachSortSelect(content);
    updateListingMobileBar();

    var mobileBarBtn = document.getElementById('property-listing-mobile-bar-btn');
    if (mobileBarBtn) {
      mobileBarBtn.addEventListener('click', closeListingSidebar);
    }

    var sidebarCloseBtn = document.getElementById('property-listing-sidebar-close');
    if (sidebarCloseBtn) {
      sidebarCloseBtn.addEventListener('click', closeListingSidebar);
    }

    var sidebar = document.getElementById('property-listing-sidebar');
    var sidebarToggle = document.getElementById('property-listing-sidebar-toggle');
    if (wrapper && sidebar && sidebarToggle) {
      function syncFiltersOpenClass() {
        var isOpen = sidebar.classList.contains('property-listing-sidebar--open');
        wrapper.classList.toggle('property-listing-filters-open', isOpen);
        document.body.classList.toggle('property-listing-filters-open', isOpen);
      }
      sidebarToggle.addEventListener('click', function () {
        setTimeout(syncFiltersOpenClass, 0);
      });
      syncFiltersOpenClass();
    }

    if (window.location.search) {
      window.history.replaceState({ listingParams: urlToParams() }, '', window.location.href);
    }

    window.addEventListener('popstate', function (e) {
      var params = (e.state && e.state.listingParams) != null ? e.state.listingParams : urlToParams();
      var form = getForm();
      if (form && Object.keys(params).length === 0) {
        form.reset();
      }
      loadListing(params, false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
